import { Directive, AfterViewInit, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
    selector: "[menuClick]"
})
export class MenuClickDirective implements AfterViewInit {
    constructor(public el: ElementRef, public renderer: Renderer2) { }

    ngAfterViewInit() {
        const dropdown = this.el.nativeElement.querySelector('ul.dropdown-menu');
        if (dropdown) {
            this.renderer.removeClass(dropdown, 'd-block');
            this.renderer.addClass(dropdown, 'd-none');
        }
    }

    @HostListener('click') onClick() {
        const dropdown = this.el.nativeElement.querySelector('ul.dropdown-menu');

        if (!dropdown) {
            return;
        }

        const isHidden = dropdown.classList.contains('d-none');

        if (isHidden) {
            this.renderer.removeClass(dropdown, 'd-none');
            this.renderer.addClass(dropdown, 'd-block');
        } else {
            this.renderer.removeClass(dropdown, 'd-block');
            this.renderer.addClass(dropdown, 'd-none');
        }
    }

    @HostListener('document:click', ['$event.target'])
    public onDocumentClick(target) {
        const clickedInside = this.el.nativeElement.contains(target);
        if (!clickedInside) {
            let hasChild = this.el.nativeElement.querySelector('ul.dropdown-menu');
            if (hasChild)
                this.renderer.setStyle(hasChild, 'display', 'none');
        }
    }
}